export const BOTTOM_INDENT_CONFIG = {
    sm: '56px',
    md: '64px',
    lg: '48px',
};
export const SEGMENT_SELECTOR_PANEL_ID = 'segment_selector_panel';
